import React from 'react';
import { Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-darkCharcoal text-white pt-20 pb-8" data-id="element-72">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-73">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16" data-id="element-74">
          {/* Column 1: Brand Info */}
          <div data-id="element-75">
            <div className="flex items-center gap-3 mb-6" data-id="element-76">
              <img src="https://cdn.magicpatterns.com/uploads/rVq7c3x7YQ1uovr6qYGM9S/Photoroom_20260412_153537.png" alt="YEI Mateo Lawn Care Logo" className="h-24 w-auto object-contain" data-id="element-77" />
              <span className="font-heading font-bold text-xl text-white" data-id="element-78">
                YEI MATEO
                <br data-id="element-79" />
                LAWN CARE
              </span>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed" data-id="element-80">
              San Diego County's Complete Exterior Team.
            </p>
            <a href="tel:6192492966" className="inline-flex items-center gap-2 text-white font-bold text-xl hover:text-accent transition-colors mb-3" data-id="element-81">
              <Phone size={24} className="text-accent" data-id="element-82" />
              (619) 249-2966
            </a>
            <a href="mailto:info@yeimateolawncare.com" className="inline-flex items-center gap-2 text-white font-bold hover:text-accent transition-colors mb-4 block" data-id="element-83">
              ✉ info@yeimateolawncare.com
            </a>
            <p className="text-gray-400 text-sm" data-id="element-84">
              Free Estimates Available
              <br data-id="element-85" />
              Call, Text, or Email Anytime
            </p>
          </div>

          {/* Column 2: Services */}
          <div data-id="element-86">
            <h4 className="font-heading font-bold text-lg mb-6 text-white uppercase tracking-wider" data-id="element-87">
              SERVICES
            </h4>
            <ul className="space-y-3 text-gray-400 columns-2 gap-x-8" data-id="element-88">
              <li data-id="element-89">• Lawn Maintenance</li>
              <li data-id="element-90">• Hardscape & Pavers</li>
              <li data-id="element-91">• Tree Trimming</li>
              <li data-id="element-92">• Stump Removal</li>
              <li data-id="element-93">• Irrigation Systems</li>
              <li data-id="element-94">• Artificial Grass</li>
              <li data-id="element-95">• Power Washing</li>
              <li data-id="element-96">• Fencing & Masonry</li>
              <li data-id="element-97">• General Clean Up</li>
              <li data-id="element-98">• Hauling</li>
              <li data-id="element-99">• Wood Decks</li>
              <li data-id="element-100">• Retaining Walls</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500 text-center md:text-left" data-id="element-101">
          <p data-id="element-102">© 2024 YEI Mateo Lawn Care. All Rights Reserved.</p>
          <p data-id="element-103">
            San Diego County, CA |{' '}
            <a href="tel:6192492966" className="hover:text-white transition-colors" data-id="element-104">
              (619) 249-2966
            </a>
          </p>
        </div>
      </div>
    </footer>;
}